export default __webpack_public_path__ + "0ad0b8bff0839f1f815a2e392c23ad61.svg";